import Flex from '@/shared/ui/Flex'

import styles from './HeroInfoTriggers.module.scss'

export type HeroInfoTriggersProps = {
	items: {
		title: string
		description?: string
		postDescription?: string
	}[]
}

/**
 * Trigger element list with title and description for HeroInfoBlock
 * @param items - trigger elements
 */
export const HeroInfoTriggers = ({ items }: HeroInfoTriggersProps): JSX.Element => (
	<div className={styles.heroInfoTriggers}>
		{items.map(item => (
			<div className={styles.item} key={item.title}>
				<Flex column>
					<h5 className={styles.title}>{item.title}</h5>
					{item.description && <p className={styles.description}>{item.description}</p>}
					{item.postDescription && <p className={styles.postDescription}>{item.postDescription}</p>}
				</Flex>
			</div>
		))}
	</div>
)
